export default {
    disease: 'بیماری خاص',
    permissionRoomsTitle: 'عنوان ',
    permissionRoomsEn: 'عنوان لاتین',
    permissionRoomsKey: ' شناسه',
}